export class SmartphotoExternalEstimation {
    ref;
    createdAt;
    updatedAt;
    carModel;
    parts;
    labour;
    paint;
    others;
    estimation;
    constructor(data) {
        this.carModel = data.estimateInfo.model;
        this.createdAt = new Date(data.estimateInfo.createdAt);
        this.updatedAt = new Date(data.estimateInfo.updatedAt);
        this.labour = data.detailedInfo.labour;
        this.paint = data.detailedInfo.painting;
        this.others = data.detailedInfo.others;
        this.parts = data.detailedInfo.pieces;
        this.ref = data.estimateInfo.estimateId;
        this.estimation = {
            currency: data.totalDamageEstimation.currency,
            discountPercentage: data.totalDamageEstimation.discountPercentage !== undefined ? Number(data.totalDamageEstimation.discountPercentage) : undefined,
            discountTotal: Number(data.totalDamageEstimation.discountTotal),
            deductibleTotal: Number(data.totalDamageEstimation.deductible),
            labourTotal: Number(data.totalDamageEstimation.labourTotal),
            othersTotal: Number(data.totalDamageEstimation.othersTotal),
            paintTotal: Number(data.totalDamageEstimation.paintingTotal),
            partsTotal: Number(data.totalDamageEstimation.piecesTotal),
            subtotal: Number(data.totalDamageEstimation.subtotal),
            taxBase: Number(data.totalDamageEstimation.taxBase),
            taxPercentage: Number(data.totalDamageEstimation.taxPercentage),
            taxTotal: Number(data.totalDamageEstimation.taxTotal),
            total: Number(data.totalDamageEstimation.total),
            totalExcDeductible: Number(data.totalDamageEstimation.totalExcDeductible)
        };
    }
    isOpen() {
        return this.estimation.total === 0;
    }
}
